import React from "react";

import Dropzone from "react-dropzone";

import {DropContainer, IconColor, UploadMessage} from './styles'
import {i18n} from "translate/i18n";

const Upload = ({onUpload, types}) => {

    const Icon = ({type}) => {
        return (
            <IconColor type={type}>
                <i className="bi bi-file-earmark"/>
            </IconColor>
        )
    }

    const renderDragMessage = (isDragActive, isDragReject) => {
        if (!isDragActive) {
            return (
                <>
                    <Icon type="default"/>
                    <UploadMessage>{i18n.t('upload.messageBox')}</UploadMessage>
                </>
            )
        }
        if (isDragReject) {
            return (
                <>
                    <Icon type="error"/>
                    <UploadMessage type="error"> {i18n.t('upload.messageError')} </UploadMessage>
                </>
            )
        }
        return (
            <>
                <Icon type="success"/>
                <UploadMessage type="success">Solte os arquivos aqui</UploadMessage>
            </>)


    }

    return (
        <>
            <Dropzone accept={types ? types : 'application/*, image/*'} onDropAccepted={onUpload}>
                {({getRootProps, getInputProps, isDragActive, isDragReject, isDragAccept, isFocused}) => (
                    <DropContainer
                        {...getRootProps()}
                        isDragActive={isDragActive}
                        isFocused={isFocused}
                        isDragReject={isDragReject}
                        isDragAccept={isDragAccept}
                    >
                        <input {...getInputProps()}/>

                        {renderDragMessage(isDragActive, isDragReject)}
                    </DropContainer>
                )}
            </Dropzone>
        </>
    )

}

export default Upload
